import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import MyTable from '../../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

//Redux
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom'
import allActions from "../../../../../actions";

// Utils
import { isEmpty } from 'lodash';
import { getConsultingId, getShortMonthName } from "../../../../utils/utils";
import { ClickAwayListener, Grow, IconButton, Menu, MenuItem, MenuList, Paper, Popper, Tooltip, Typography } from "@material-ui/core";
import { unoTheme } from "../../../../../assets/styles/unoTheme";

import { doGetStatusXmlAudespClientsByYear, STATUS_DAIR } from "../../../../../controllers/ClientController";

import SearchBar from "../../../../utils/SearchBar";
import { StatusDpinDairAPI } from "../../../../../API/status_dpin_dair";
import { path } from "../../../../utils/routesPaths";
import { ClientAPI } from "../../../../../API/client";

import { classificationsMap } from '../../../backOffice/NewClientScreen';
import CommentIcon from '@material-ui/icons/Comment';
import SortIcon from '@material-ui/icons/Sort';

const QUARTER_LABELS = ['1ºTri DREI', '2ºTri DREI', '3ºTri DREI', '4ºTri DREI'];

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },

    triColumn: {
        background: '#fdffe0 !important',
        borderBottom: 'solid 0.2px #efefef !important',
        '&.MuiTableCell-body': {
            cursor: "pointer",
            '&:hover': {
                background: '#fbffc7 !important',
            }
        }
    },

    commentIcon: {
        cursor: "pointer",
        color: unoTheme.mainGrayColor,

        '&:hover': {
            color: unoTheme.mainColor,
        }
    },

    hoverHeader: {
        cursor: "pointer",
        '&:hover': {
            color: unoTheme.mainColor + " !important",
        }
    },
}));

export default function XmlAudespTab(props) {

    const { selectedYearClosure, selectedAdvisor, selectedXmlAudespFilter, filterMonth } = props;

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser)

    const [statusesXmlAudesp, setStatusesXmlAudesp] = useState(null);
    const [statusesXmlAudespTri, setStatusesXmlAudespTri] = useState(null);
    const [statusClientsArray, setStatusClientsArray] = useState(null);
    const [search, setSearch] = useState("");

    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);

    const [sortOrder, setSortOrder] = useState('alpha_asc');
    const [sortMenuAnchor, setSortMenuAnchor] = useState(null);

    const LIMIT = 30;

    //Popper troca de status (mês ou trimestre)
    const [openChangeStatusMenu, setOpenChangeStatusMenu] = useState(false);
    const anchorRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCellInfo, setSelectedCellInfo] = useState(null);

    async function loadStatuses() {
        const responseMonths = await StatusDpinDairAPI.getStatusesXmlAudesp();
        if (responseMonths.success) {
            setStatusesXmlAudesp(responseMonths.body.rows);
        }
        const responseTri = await StatusDpinDairAPI.getStatusesXmlAudespTri();
        if (responseTri.success) {
            setStatusesXmlAudespTri(responseTri.body.rows);
        }
    }

    async function loadClients(page, year, search) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando clientes...'
        }));

        setStatusClientsArray(null);
        const offset = (page - 1) * LIMIT;

        const advisorToFilter = selectedAdvisor && selectedAdvisor.id ? selectedAdvisor.id : null;

        const response = await doGetStatusXmlAudespClientsByYear(
            offset,
            advisorToFilter == null && isEmpty(search) && !selectedXmlAudespFilter ? LIMIT : 'NO_PAGINATION',
            year,
            advisorToFilter,
            getConsultingId(currentUser),
            search,
            sortOrder
        );

        if (response.success && response.body && response.body.length) {
            setStatusClientsArray(response.body);
            setTotalItems(response.totalItems);
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: false,
            }));
        } else {
            setStatusClientsArray(null);
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                emptyMessage: "Nenhum cliente encontrado",
            }));
        }
    }

    const handleChange = (value) => {
        const newPage = page + value;
        setPage(newPage);
        loadClients(newPage, selectedYearClosure, search);
    };

    const handleToggle = () => {
        setOpenChangeStatusMenu((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpenChangeStatusMenu(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenChangeStatusMenu(false);
        }
    }

    function openChangeStatus(target, type, period, selectedClient) {
        setSelectedCellInfo({
            client: selectedClient,
            type: type, //'month' | 'tri'
            period: period, //número do mês (1-12) ou do trimestre (1-4)
            year: selectedYearClosure,
        })
        handleToggle();
        setAnchorEl(target);
    }

    async function doChangeStatus(infoCell, statusSelected) {

        handleClose({ target: null });

        let response;
        if (infoCell.type === 'tri') {
            response = await StatusDpinDairAPI.changeStatusXmlAudespTri(statusSelected.id,
                infoCell.client.id, currentUser.user.id, infoCell.period, infoCell.year);
        } else {
            response = await StatusDpinDairAPI.changeStatusXmlAudesp(statusSelected.id,
                infoCell.client.id, currentUser.user.id, infoCell.period, infoCell.year);
        }

        if (response.success) {
            updateViewStatus(infoCell, statusSelected);
        }
    }

    function updateViewStatus(infoCell, newStatus) {
        const newValuesStatusClientsArray = [...statusClientsArray];
        const clientToChange = newValuesStatusClientsArray.find(el => el.id == infoCell.client.id);

        if (clientToChange) {
            if (infoCell.type === 'tri') {
                clientToChange['Q' + infoCell.period] = {
                    status_xml_audesp_tri_id: newStatus.id,
                    xml_audesp_tri_name: newStatus.name,
                    xml_audesp_tri_short_name: newStatus.short_name,
                    xml_audesp_tri_color: newStatus.color,
                    xml_audesp_tri: infoCell.period,
                };
            } else {
                clientToChange[infoCell.period] = {
                    status_xml_audesp_id: newStatus.id,
                    xml_audesp_name: newStatus.name,
                    xml_audesp_short_name: newStatus.short_name,
                    xml_audesp_color: newStatus.color,
                    xml_audesp_month: infoCell.period,
                };
            }
            setStatusClientsArray(newValuesStatusClientsArray);
        }
    }

    function renderMenuChangeStatus() {
        const items = (selectedCellInfo && selectedCellInfo.type === 'tri')
            ? statusesXmlAudespTri
            : statusesXmlAudesp;

        if (!items) return [];

        return items.map(item => (
            <MenuItem
                key={'menu-xml-audesp-' + item.id}
                onClick={() => doChangeStatus(selectedCellInfo, item)}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{
                        backgroundColor: item.color,
                        width: '8px',
                        height: '8px',
                        marginRight: '6px',
                        borderRadius: '50%'
                    }}></div><Typography style={{ fontSize: '10px' }}>{item.short_name} - {item.name}</Typography>
                </div>
            </MenuItem >
        ));
    }

    //Informações de exibição de uma célula de mês
    function getMonthInfo(clientRow, month) {
        const cell = clientRow[month];

        if (cell === STATUS_DAIR.unneeded) {
            return { name: '', shortName: '-', color: '', clickable: false };
        } else if (cell === STATUS_DAIR.pendent) {
            const s = statusesXmlAudesp[0]; //PEND
            return { name: s.name, shortName: s.short_name, color: s.color, clickable: true };
        } else {
            return { name: cell.xml_audesp_name, shortName: cell.xml_audesp_short_name, color: cell.xml_audesp_color, clickable: true };
        }
    }

    //Informações de exibição de uma célula de trimestre
    function getTriInfo(clientRow, tri) {
        const cell = clientRow['Q' + tri];

        if (cell === STATUS_DAIR.pendent || !cell) {
            const s = statusesXmlAudespTri[0]; //PEND
            return { name: s.name, shortName: s.short_name, color: s.color };
        } else {
            return { name: cell.xml_audesp_tri_name, shortName: cell.xml_audesp_tri_short_name, color: cell.xml_audesp_tri_color };
        }
    }

    function renderColumnsStatus(clientRow) {

        const columnsClient = [];

        //Meses
        for (let monthLoop = 1; monthLoop <= 12; monthLoop++) {
            const info = getMonthInfo(clientRow, monthLoop);

            columnsClient.push(
                <TableCell
                    key={'xml-audesp-month-' + clientRow.id + '-' + monthLoop}
                    onClick={(e) => info.clickable
                        ? openChangeStatus(e.currentTarget, 'month', monthLoop, clientRow)
                        : null}
                    align="center"
                    style={info.clickable ? { paddingLeft: '2px', paddingRight: '2px' } : { pointerEvents: 'none', paddingLeft: '4px', paddingRight: '4px' }}>
                    <Tooltip button
                        title={info.name}
                        enterDelay={200}
                        leaveDelay={100}
                        placement="bottom"
                        arrow>
                        <div style={{
                            fontWeight: '600',
                            fontSize: '10px',
                            letterSpacing: '1px',
                            color: info.color,
                        }}>{info.shortName}</div>
                    </Tooltip>
                </TableCell>
            );
        }

        //Trimestres
        for (let triLoop = 1; triLoop <= 4; triLoop++) {
            const info = getTriInfo(clientRow, triLoop);

            columnsClient.push(
                <TableCell
                    key={'xml-audesp-tri-' + clientRow.id + '-' + triLoop}
                    className={classes.triColumn}
                    onClick={(e) => openChangeStatus(e.currentTarget, 'tri', triLoop, clientRow)}
                    align="center">
                    <Tooltip button
                        title={info.name}
                        enterDelay={200}
                        leaveDelay={100}
                        placement="bottom"
                        arrow>
                        <div style={{
                            fontWeight: '600',
                            fontSize: '10px',
                            letterSpacing: '1px',
                            color: info.color,
                        }}>{info.shortName}</div>
                    </Tooltip>
                </TableCell>
            );
        }

        return columnsClient;
    }

    function handleOpenTotalizer(periodType, period) {
        dispatch(allActions.rightContentActions.setRightContent({
            path: "statusesClientsByMonth",
            data: {
                mode: periodType === 'tri' ? 'XML_AUDESP_TRI' : 'XML_AUDESP_MONTH',
                period: period,
                year: selectedYearClosure,
                advisorId: selectedAdvisor && selectedAdvisor.id,
                consultingId: getConsultingId(currentUser),
                search: search,
                xmlAudespStatusIdFilter: periodType === 'tri'
                    ? null
                    : (selectedXmlAudespFilter && selectedXmlAudespFilter.id),
                snapshotDate: null,
            }
        }))
    }

    async function detailClient(clientId) {

        const clientSelected = await ClientAPI.getClientById(clientId);

        if (clientSelected.success) {
            history.push(
                {
                    pathname: path.administration.client.details.newClient,
                    state: { client: clientSelected.body }
                }
            )
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao carregar cliente",
                type: 'error',
            }));
        }
    }

    useEffect(() => {
        loadStatuses();
    }, []);

    useEffect(() => {
        setPage(1);
        loadClients(1, selectedYearClosure, search);
    }, [selectedYearClosure, search, selectedXmlAudespFilter, selectedAdvisor, sortOrder]);

    //Status efetivo (id) de um mês de um cliente, considerando registro/fallback
    function getMonthStatusId(clientRow, month) {
        const cell = clientRow[month];
        if (cell === STATUS_DAIR.unneeded) return null;
        if (cell === STATUS_DAIR.pendent) return statusesXmlAudesp && statusesXmlAudesp[0] ? statusesXmlAudesp[0].id : null;
        return cell.status_xml_audesp_id;
    }

    //Filtro por status do mês selecionado (filterMonth)
    const displayedClients = (statusClientsArray && selectedXmlAudespFilter && filterMonth && statusesXmlAudesp)
        ? statusClientsArray.filter(row => getMonthStatusId(row, filterMonth) == selectedXmlAudespFilter.id)
        : statusClientsArray;

    return (
        <div className={classes.root}>

            <div class={'defaultScrollWithHeaderContent'}>

                <MyTable
                    pagination={
                        isEmpty(search) &&
                        !selectedXmlAudespFilter &&
                        (selectedAdvisor == null || selectedAdvisor.id == null) &&
                        statusClientsArray
                        && statusClientsArray.length > 0
                    }
                    itemspage={LIMIT}
                    totalitems={totalItems}
                    currentPage={page}
                    handlePage={handleChange}
                    stickyHeader
                    withBorderColumn
                    size="small">
                    <colgroup>
                        <col width="18%" />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                align="left"
                                style={{ paddingLeft: '0px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <SearchBar
                                        name='search_query'
                                        mask='text_cnpj'
                                        size='small'
                                        spacingRight
                                        variant='outlined'
                                        label='Cliente'
                                        setSearchQuery={setSearch}
                                    />
                                    <Tooltip title="Ordenação" placement="top" arrow>
                                        <IconButton size="small" onClick={(e) => setSortMenuAnchor(e.currentTarget)}>
                                            <SortIcon style={{ color: sortOrder !== 'alpha_asc' ? '#1976d2' : undefined }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </TableCell>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => (
                                <TableCell
                                    key={'header-xml-audesp-month-' + month}
                                    className={classes.hoverHeader}
                                    align="center"
                                    onClick={() => handleOpenTotalizer('month', month)}>{getShortMonthName(month)}</TableCell>
                            ))}
                            {QUARTER_LABELS.map((label, index) => (
                                <TableCell
                                    key={'header-xml-audesp-tri-' + index}
                                    className={classes.hoverHeader}
                                    align="center"
                                    style={{ color: unoTheme.mainColor }}
                                    onClick={() => handleOpenTotalizer('tri', index + 1)}>{label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {statusesXmlAudesp && statusesXmlAudespTri && displayedClients
                            && displayedClients.map((row) => (
                                <TableRow
                                    key={'xml-audesp-client-' + row.id}>
                                    <TableCell
                                        onClick={() => detailClient(row.id)}
                                        align="left">
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div>{row.label_name}</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                {row.classification && (
                                                    <div style={{
                                                        borderRadius: '4px',
                                                        background: classificationsMap[row.classification]?.color,
                                                        padding: '1px 6px',
                                                        fontSize: '10px',
                                                        color: '#fff',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                    }}>
                                                        {row.classification}
                                                    </div>
                                                )}
                                                <CommentIcon className={classes.commentIcon}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        dispatch(allActions.rightContentActions.setRightContent({
                                                            path: 'statusesClientHistoricXmlAudesp',
                                                            data: {
                                                                year: selectedYearClosure,
                                                                clientId: row.id,
                                                            }
                                                        }))
                                                    }} />
                                            </div>
                                        </div>
                                    </TableCell>
                                    {renderColumnsStatus(row)}
                                </TableRow>
                            ))}
                    </TableBody>
                </MyTable>
            </div>

            <Popper
                open={openChangeStatusMenu}
                anchorEl={anchorEl}
                transition
                disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                {openChangeStatusMenu ?
                                    <div>
                                        <Typography style={{ fontSize: '12px', padding: '8px', borderBottom: 'solid 1px #eeeeee' }}>{selectedCellInfo && (selectedCellInfo.client.label_name + ' (' + (selectedCellInfo.type === 'tri' ? selectedCellInfo.period + 'º Tri' : getShortMonthName(selectedCellInfo.period)) + '/' + selectedCellInfo.year + ")")}</Typography>

                                        <MenuList style={{ maxHeight: '150px', overflowY: 'scroll' }} autoFocusItem={openChangeStatusMenu} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                            {renderMenuChangeStatus()}
                                        </MenuList>

                                    </div> : <div></div>
                                }
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

            <Menu
                id="sort-order-menu-xml-audesp"
                anchorEl={sortMenuAnchor}
                keepMounted
                open={Boolean(sortMenuAnchor)}
                onClose={() => setSortMenuAnchor(null)}>
                {[
                    { value: 'priority_desc', label: 'Ordenar por prioridade Desc' },
                    { value: 'priority_asc', label: 'Ordenar por prioridade Asc' },
                    { value: 'alpha_asc', label: 'Ordenar Alfabética Asc' },
                    { value: 'alpha_desc', label: 'Ordenar Alfabética Desc' },
                ].map(opt => (
                    <MenuItem
                        key={opt.value}
                        selected={sortOrder === opt.value}
                        onClick={() => { setSortOrder(opt.value); setSortMenuAnchor(null); }}>
                        <Typography style={{ fontSize: '13px' }}>{opt.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>

        </div>
    );
}
